export default function Quality (){
   
   
    return (
        <div className="container--big-row">
        <div className="quality-container">
        <div className="content--description right-description">
            <h3 className="content-section--2title special-color content--text-right">QUALITY HOSTING</h3>
            <h1 className="content-section--1title content--text-right">Meets Exceptional <span className="special-color-1">Performance.</span></h1>
            <p className="content-section--para content-section--para-left">Our cutting-edge infrastructure and unwavering commitment to excellence ensure your website enjoys blazing-fast speeds, unbeatable uptime, and top-notch security. Discover a hosting experience that's tailor-made for your success – from shared hosting to dedicated servers, we're here to elevate your online presence to new heights.</p>
            <div className="button-space"><button className="btn no-cursor">Learn More</button></div>
        </div>
<figure className="content--img-container"><img  src="undraw_pet_adoption_-2-qkw.svg"/></figure>

        </div>
        </div>
        
        )
}